module.exports = __webpack_public_path__ + "img/3.568ee094.jpg";